// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-sidebar/SidebarE... Remove this comment to see the full error message
import SidebarError from 'customer-data-sidebar/SidebarError';
import RecordsErrorBoundary from '../../errors/RecordsErrorBoundary';
import CardsSidebar from '../sidebar/CardsSidebar';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-sidebar/universa... Remove this comment to see the full error message
import { CRM_RECORD_RIGHT } from 'customer-data-sidebar/universal/cardLocationConstants';
import { NavMarker } from 'react-rhumb';
import PerformanceMarker from 'crm-fe-perf/timing/PerformanceMarker';
import { RightSidebarLoaded } from 'crm-fe-perf/timing/marks/crm-records-ui/performanceMarks';
import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-objects-ui-compo... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { useMemo } from 'react';
import { View } from 'foundations-components/components/View';
import FullHeightScrollContainer from './common/components/FullHeightScrollContainer';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'styled-components';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const CardsContainer = styled.div.withConfig({
  displayName: "RightSidebar__CardsContainer",
  componentId: "sc-187ulrp-0"
})(["flex-grow:1;display:flex;"]);
const scrollContainerProps = {
  'data-scroll-trackable-container': 'right-sidebar'
};
const RightSidebar = ({
  objectType,
  onCommunicatorClick,
  subjectId
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const successMarker = useMemo(() => /*#__PURE__*/_jsx(PerformanceMarker, {
    marker: RightSidebarLoaded
  }), []);
  const errorMarker = useMemo(() => /*#__PURE__*/_jsx(NavMarker, {
    name: "RIGHT_SIDEBAR_ERROR"
  }), []);
  return /*#__PURE__*/_jsx(View, {
    as: "aside",
    "data-selenium-test": "right-sidebar",
    "data-test-id": "right-sidebar",
    blockSize: "100%",
    children: /*#__PURE__*/_jsx(FullHeightScrollContainer, {
      scrollContainerProps: scrollContainerProps,
      children: /*#__PURE__*/_jsx(RecordsErrorBoundary, {
        ErrorComponent: SidebarError,
        boundaryName: "ProfileThreeColumn_RightSidebarError",
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          minBlockSize: "100%",
          paddingBlockEnd: "1300",
          paddingInlineEnd: isTrellis ? '600' : undefined,
          children: /*#__PURE__*/_jsx(CardsContainer, {
            children: /*#__PURE__*/_jsx(View, {
              inlineSize: "100%",
              marginBlockStart: isTrellis ? '600' : '0',
              children: /*#__PURE__*/_jsx(CardsSidebar, {
                cardLocation: CRM_RECORD_RIGHT,
                HighlightComponent: null,
                objectType: objectType,
                onCommunicatorClick: onCommunicatorClick,
                showIntegrationCards: true,
                subjectId: subjectId,
                RhumbMarkerSuccess: successMarker,
                RhumbMarkerError: errorMarker
              })
            })
          })
        })
      })
    })
  });
};
RightSidebar.propTypes = {
  onCommunicatorClick: PropTypes.func,
  objectType: AnyCrmObjectTypePropType,
  subjectId: PropTypes.string.isRequired
};
export default RightSidebar;